<ng-container *ngIf="newHomePedirDelivery">
	<div *ngIf="item.type != 'general' || item.hasStock !== false || showStockPausedItems() || allRequiredExtrasOutOfStock"
		data-cy="menuItem"
		class="product-card-new-design hover-anim"
		[ngClass]="{'card-product__without-stock' : item.hasStock === false, 'product-card--disabled' : allRequiredExtrasOutOfStock, 'product-card--list': !isFeatured, 'product-card--no-description': !isFeatured && !item.description && !item.tag, 'product-card--no-image': !hasImageSlot, 'product-card--no-text': !hasTextBlock}"
		(click)="!allRequiredExtrasOutOfStock && goToItemPage(item)">
		<div class="card-container">
			<div class="info-container" [class.title-short]="isShortTitle()">
				<div class="tag-container" *ngIf="item.tag">
					<span class="product-tag">{{item.tag}}</span>
				</div>
				<h3 class="item-name">{{item.name}}</h3>
				<p class="unavailable-text" *ngIf="item.hasStock === false || allRequiredExtrasOutOfStock" data-cy="hasStock">
					Indisponível no momento
				</p>
				<div *ngIf="hasTextBlock" class="text-block" [class.has-tag]="item.tag">
					<p *ngIf="isInstagramUA && item.description" class="item-description">
						{{descriptionText}}
					</p>
					<!-- DIV, não P: a descrição vem do editor com <p> (204 de 214 produtos em 6 lojas). <p> dentro
					     de <p> o render do servidor desmonta, e a hidratação duplicava a descrição do card nas
					     páginas do SSR (23/09/2026). O corte de linhas (line-clamp) vale igual num div. -->
					<div *ngIf="!isInstagramUA && item.description"
					[innerHTML]="descriptionHtml"
					class="item-description">
					</div>
				</div>
				<div class="price-container">
					<div *ngIf="item.price > 0 && !item.fromPrice" class="price-content">
						<span class="current-price">{{item.price | multiCurrency}}</span>
						<span *ngIf="showOldPrice" class="old-price">{{item.oldPrice | multiCurrency}}</span>
					</div>
					<div *ngIf="item.fromPrice" class="price-content">
						<span class="from-text">{{'From_price' | translate}} </span>
						<span class="price-value">{{item.fromPrice | multiCurrency}}</span>
						<span *ngIf="showOldPrice" class="old-price">{{item.oldPrice | multiCurrency}}</span>
					</div>
				</div>
			</div>
			
			<div *ngIf="hasImageSlot" class="image-container" (click)="item.image && openViewer(item); $event.stopPropagation();">
				<mp-img *ngIf="item.image" class="item-image" [imgURL]="miniatura" [original]="miniaturaOriginal"></mp-img>
				<img *ngIf="!item.image && isFeatured" class="item-image" [src]="defaultImage" alt="{{item.name}}">
			</div>
		</div>
	</div>
</ng-container>

<ng-container *ngIf="!newHomePedirDelivery">
	<!-- Recriado sem Ionic (mp-*): fiel ao ion-card/grid/col/card-header/title/content/label/text (md). -->
	<div *ngIf="item.type != 'general' || item.hasStock !== false || showStockPausedItems() || allRequiredExtrasOutOfStock" data-cy="menuItem" class="mp-card product-card hover-anim" [ngClass]="{'card-product__without-stock' : item.hasStock === false, 'product-card--disabled' : allRequiredExtrasOutOfStock}" (click)="!allRequiredExtrasOutOfStock && goToItemPage(item)">
		<div class="mp-grid">
			<div class="mp-row">
				<div class="mp-col mp-col-3 p-0 centralize" *ngIf="item.image">
					<mp-img class="item-image" [imgURL]="miniatura" [original]="miniaturaOriginal" (click)="openViewer(item); $event.stopPropagation();"></mp-img>
				</div>
				<div class="mp-col p-0" [ngClass]="item.image ? 'mp-col-9' : 'mp-col-12'">
					<div class="mp-card-header pb-0">
						<h2 class="mp-card-title text-wrap item-name">{{item.name}}</h2>
						<span class="mp-label text-wrap text-right" *ngIf="item.hasStock === false || allRequiredExtrasOutOfStock" data-cy="hasStock">
							Indisponível no momento
						</span>
					</div>
					<div class="mp-card-content">
						<!-- `hasDescription` (Caso 17-B): os dois spans da descrição não tinham *ngIf —
						     nasciam VAZIOS em todo produto sem descrição, que é a esmagadora maioria
						     numa distribuidora. O `<br>` abaixo NÃO sai junto: medido, ele vale ~21px
						     de altura em TODO card (é ele que separa descrição de preço). -->
						<span class="mp-label text-wrap" *ngIf="isInstagramUA && hasDescription">{{descriptionText}}</span>
						<span class="mp-label text-wrap" *ngIf="!isInstagramUA && hasDescription"><span [innerHTML]="descriptionHtml"></span></span>
						<br>
						<span class="mp-label product-card-label" *ngIf="item.price > 0 && !item.fromPrice">
							{{item.fromPrice}}
							<b *ngIf="showOldPrice"><del style="color:grey;">{{item.oldPrice | multiCurrency}}</del>&nbsp;</b>
							<b>{{item.price | multiCurrency}}</b>
						</span>
						<span class="mp-label product-card-label" *ngIf="item.fromPrice">
							<b>{{'From_price' | translate}} </b>
							<del style="color:grey;" *ngIf="showOldPrice">{{item.oldPrice | multiCurrency}} </del>
							<b>{{item.fromPrice | multiCurrency}}</b>
						</span>
					</div>
				</div>
			</div>
			<div class="mp-row" *ngIf="item.tag">
				<div class="mp-col mp-col-12 text-center">
					<span class="mp-text product-tag">{{item.tag}}</span>
				</div>
			</div>
		</div>
	</div>
</ng-container>
